(function ($) {
  $(function () {
    if ($('.stats .row-wrap .col-three .wrap .counter-number').length) {
      $('.stats .row-wrap .col-three .wrap .counter-number').each(function() {
        var value = $(this).text().trim();
        if (value !== "") {
          $(this).counterUp({
            delay: 80,
            time: 3000
          });
        }
      });
    }
  });
})(jQuery);